import React from 'react';
import {
  Route,
  Redirect,
} from 'react-router-dom';

import Header from './Header'

const PrivateRoute = ({component: Component, ...rest}) => {

    if (rest.auth === null) return (null);

    // if(!rest.auth.success) {
        //console.log(rest)
        // rest.rememberOriginalPath(rest.location.pathname)
    // }

    return (
        (rest.auth.success === false || (rest.auth.success === true && rest.auth.user.isGuest===true))
            ? (<Redirect to="/landing" from={rest.location.pathname}/>)
            : (<Route {...rest}
                    render={(props)=>{return(
                        <div>
                            {
                                (!rest.noheader)
                                    ? <Header {...props} {...rest} />
                                    : null
                            }
                            <Component  {...props} {...rest} />
                        </div>
                    )}}
                />)
                //component={Component}/>) //<Component {...rest} auth={rest.auth}/>)

    );
}

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js